<template>
  <section>
    <div class="menu flex-between-center">
      <div
        v-for="item in menuItemsMobile"
        :key="item.title"
        :class="['menu__item', { active: item.route === currentRoute }]"
        @click="$router.push(item.route)"
      >
        <svg :class="['menu__item-icon', { active: item.route === currentRoute }]">
          <use :xlink:href="`#${item.icon}`" />
        </svg>
        <div :class="['menu__item-title', { active: item.route === currentRoute }]">
          {{ item.title }}
        </div>
        <div class="menu__item-dot" />
      </div>
    </div>
    <menu-svg-sprite />
  </section>
</template>

<script>
import { menuItemsMobile } from './menuContent'
import MenuSvgSprite from './MenuSvgSprite'

export default {
  name: 'DriverBottomMenu',
  components: { MenuSvgSprite },
  data() {
    return {
      menuItemsMobile,
      activeRoute: '',
    }
  },
  computed: {
    currentRoute() {
      return this.$route.path
    },
  },
  created() {
    this.filLibs()
  },
}
</script>

<style lang="sass" scoped>
@import "@/assets/styles/driver-styles.sass"
.menu
  position: fixed
  bottom: 0
  left: 0
  right: 0
  height: 7rem
  padding: 0 1.25rem
  background-color: #FFFFFF
  box-shadow: 0 0 3rem rgba(132, 132, 132, 0.25)
  z-index: 100
  &__item
    width: 7rem
    height: 100%
    padding-top: 1.4rem
    text-align: center
    overflow: hidden
    transition: all .2s ease
    &.active
      padding-top: 0.8rem
    &-icon
      width: 2.4rem
      height: 2.4rem
      margin-bottom: .2rem
      fill: #9D9D9D
      &.active
        fill: $mainColor
    &-title
      margin-bottom: 2rem
      font-weight: 400
      font-size: 1.2rem
      line-height: 1.6rem
      color: #747474
      transition: margin-bottom .2s ease
      &.active
        margin-bottom: 1rem
        font-weight: 700
        color: $mainColor
    &-dot
      margin: 0 auto
      width: 0.4rem
      height: 0.4rem
      border-radius: 50%
      background: $mainColor
</style>
